/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import InputMinusIcon from "../../assets/icons/InputMinusIcon";
import InputPlusIcon from "../../assets/icons/InputPlusIcon";

function FormQuantity({
    control,
    defaultValue = 0,
    disabled,
    editable,
    max,
    min = 0,
    name,
    step = 1,
}) {
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue || 0}
            render={({ field }) => (
                <div className="input-quantity">
                    <button
                        disabled={disabled || field.value <= min}
                        type="button"
                        onClick={() => {
                            const newValue = parseFloat(field.value) - step;
                            field.onChange(newValue < min ? min : newValue);
                        }}
                    >
                        <InputMinusIcon />
                    </button>
                    <input
                        autoComplete="off"
                        className={`text-link ${
                            field.value <= 0 ? "disabled" : undefined
                        }`}
                        min={min}
                        max={max}
                        disabled={!editable}
                        onChange={field.onChange}
                        onFocus={(event) => event.target.select()}
                        type="number"
                        value={field.value}
                    />
                    <button
                        disabled={disabled || field.value >= max}
                        type="button"
                        onClick={() => {
                            const newValue = parseFloat(field.value) + step;
                            field.onChange(
                                max && newValue > max ? max : newValue
                            );
                        }}
                    >
                        <InputPlusIcon />
                    </button>
                </div>
            )}
        />
    );
}

FormQuantity.propTypes = {
    name: PropTypes.string.isRequired,
    control: PropTypes.shape({}).isRequired,
    step: PropTypes.number,
    min: PropTypes.number,
    max: PropTypes.number,
    editable: PropTypes.bool,
    disabled: PropTypes.bool,
    defaultValue: PropTypes.number,
};

FormQuantity.defaultProps = {
    defaultValue: 0,
    step: 1,
    min: 0,
    max: undefined,
    editable: false,
    disabled: false,
};

export default FormQuantity;
